import { render, staticRenderFns } from "./status-info.vue?vue&type=template&id=6652aef8&scoped=true&"
import script from "./status-info.vue?vue&type=script&lang=js&"
export * from "./status-info.vue?vue&type=script&lang=js&"
import style0 from "./status-info.vue?vue&type=style&index=0&id=6652aef8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6652aef8",
  null
  
)

export default component.exports